import { getGameItemConfig } from "@/stores/configStore.ts";
import { GuessYouLikeAttrs } from "@locent/types";

import { BaseComponent } from "../base/baseComponent";
import { CompType, GameIconStyle, ProviderStyle } from "../base/baseEnum";
import { type GameItem } from "../base/baseType";

/** 猜你喜欢组件类 */
export class GuessYouLikeComponent extends BaseComponent<
  GuessYouLikeAttrs & {
    [key: string]: string | number | boolean | object | null | undefined;
  }
> {
  public list: GameItem[] = [];

  constructor(
    data: Partial<
      BaseComponent<
        GuessYouLikeAttrs & {
          [key: string]: string | number | boolean | object | null | undefined;
        }
      >
    > = {},
  ) {
    super(data);
    this.type = CompType.guess_you_like;
  }

  /** 获取标题 */
  public getTitle(): string {
    return this.title || "";
  }

  /** 获取自定义图标文件夹 */
  public getIconFolder(): string {
    return this.lang_attrs.icon_folder || "";
  }

  /** 获取图标设置类型 */
  public getIconSetType(): number {
    return this.lang_attrs.icon_set_type || 0;
  }

  /** 获取图标样式 */
  public getIconStyle(): GameIconStyle {
    return (
      (this.lang_attrs.icon_style as GameIconStyle) || GameIconStyle.Default
    );
  }

  /** 获取图标圆角 */
  public getIconRadius(): number {
    // return Number(this.lang_attrs.icon_radius);
    return this.lang_attrs.icon_set_type && this.lang_attrs.icon_radius
      ? Number(this.lang_attrs.icon_radius)
      : getGameItemConfig().gameIconRadius;
  }

  /** 获取提供商样式 */
  public getProviderStyle(): ProviderStyle {
    return (
      (this.lang_attrs.provider_style as ProviderStyle) || ProviderStyle.Default
    );
  }

  /** 获取原始图标文件夹 */
  public getOrgIconFolder(): string {
    return this.lang_attrs.org_icon_folder || "";
  }

  /** 获取扩展图标文件夹 */
  public getExtIconFolder(): string {
    return this.lang_attrs.ext_icon_folder || "";
  }
}
